import { render, staticRenderFns } from "./WsCrud.vue?vue&type=template&id=a7ff4a6e&"
import script from "./WsCrud.vue?vue&type=script&lang=js&"
export * from "./WsCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports